import { useState, useCallback, useEffect, Dispatch, SetStateAction, useMemo } from 'react';
import { opportunitiesServices } from 'shared/services/opportunitiesServices';
import { IProjectAttributes } from 'shared/interfaces/IProject';

const { getOpportunities } = opportunitiesServices();
export const useAppliedOpportunities = (
  setAppliedDataState: Dispatch<SetStateAction<IProjectAttributes[]>>,
  appliedDataState: IProjectAttributes[],
) => {
  const [enabled, setEnabled] = useState(false);
  const {
    data,
    fetchNextPage: fetchNextApplied,
    hasNextPage: appliedHasNextPage,
    isLoading: appliedFetching,
    isFetchingNextPage: appliedRefetching,
  } = getOpportunities(
    {
      tab_filter: 'submitted',
    },
    {
      enabled,
    },
  );

  const appliedData = useMemo(() => {
    //get last index of pages and concat all opportunities
    const lastPage = data?.pages[data.pages.length - 1];
    return data ? lastPage?.data.opportunities_connection.nodes : [];

    // return data ? [].concat(...data.pages.map((page: any) => page.data.opportunities_connection.nodes)) : [];
  }, [data]);

  const fetchMoreApplied = useCallback(() => {
    if (appliedHasNextPage && !appliedRefetching) {
      fetchNextApplied();
    }
  }, [fetchNextApplied, appliedHasNextPage, appliedRefetching]);

  const getAppliedOpportunities = useCallback(() => {
    if (enabled) return;
    setAppliedDataState([]);
    setEnabled(true);
  }, [setAppliedDataState, enabled]);

  const pushProjectToApplied = useCallback(
    (project: IProjectAttributes) => {
      if (enabled) {
        setAppliedDataState((prevOpportunities) => prevOpportunities.concat(project));
      }
    },
    [enabled, setAppliedDataState],
  );

  useEffect(() => {
    //staggered fetching
    if (appliedDataState.length < 4 && appliedHasNextPage) {
      fetchMoreApplied();
    }
  }, [appliedDataState, appliedHasNextPage, fetchMoreApplied]);

  useEffect(() => {
    if (!appliedData) return;
    setAppliedDataState((prev) => prev.concat(appliedData));
  }, [appliedData, setAppliedDataState]);

  return {
    pushProjectToApplied,
    getAppliedOpportunities,
    appliedFetching,
    fetchMoreApplied,
    appliedRefetching,
  };
};
